import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/config/site";
import { Reveal, ChapterTag } from "./Reveal";

export const FaqSection = () => (
  <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 bg-white border-t border-brand-ink/8">
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <Reveal className="text-center">
        <div className="flex justify-center"><ChapterTag num="06" label="Dudas resueltas" /></div>
        <h2 className="font-display font-extrabold tracking-tight text-brand-ink text-3xl sm:text-4xl lg:text-5xl mt-5">
          Preguntas frecuentes
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12 space-y-4">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-brand-smoke border border-brand-ink/6 rounded-2xl px-6 overflow-hidden data-[state=open]:bg-white data-[state=open]:border-brand-yellow data-[state=open]:shadow-[0_12px_40px_rgba(18,19,22,0.07)] transition-[background-color,border-color,box-shadow] duration-300"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="font-display font-bold text-base sm:text-lg text-brand-ink text-left py-5 hover:no-underline"
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="text-brand-ink/65 text-[15px] leading-relaxed pb-6">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
